import { useAddAlert } from '@/hooks/useAddAlert'
import { selectProfile } from '@store/profile.reducer'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import iclasses from '@pages/Admin/CRM/styles/input.module.css'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import classes from './index.module.css'
import { useEffect, useState } from 'react'
import {
  ArrowListExpand,
  EditIcoNewDesign,
  IcoEdit,
  IconDone,
  IcoRemove,
} from '@/utils/icons'
import Preloader from '@UI/Preloader'
import {
  API,
  classApi,
  courseAPI,
  departments,
  directionOrdersApi,
  directionGroupApi,
  massActionsApi,
  usersAPI,
} from '@/api'
import { getAvatar } from '@/helpers/getAvatar'
import Button from '@UI/Button'
import { TablePaymentsDiscounts } from '@UI/TablePaymentsDiscounts'
import Modal, { ModalContainer } from '@common/Modal'
import { BodyModal } from '@common/ProfileCard/BodyModal/BodyModal'
import { DatePicker, Tabs } from 'antd'
import Select from '@UI/Select'
import dayjs from 'dayjs'
import { AuthService } from '@/services/AuthService'
import Moment from 'react-moment'
import ModalRemoveClass from '@common/ProfileCard/BodyEdit/ModalRemoveClass'
import { Tooltip } from 'antd'
import ModalRecoverPassword from '../../Colleges/modals/ModalRecoverPassword'
import setSettingsFromServer from '@/helpers/setSettingsFromServer'
import ActionModal from '../ActionModal'
import SelectDepartmentModal from '../SelectDepartmentModal'
import { CloseOutlined, EditOutlined } from '@ant-design/icons'
import { Select as SelectAnt, Modal as ModalAnt } from 'antd'
import { useAsyncFn } from 'react-use'
import { isError } from '@/helpers/checkQuery'
import UserSearch from '../../components/UserSearch'
import UserBlock from '../../components/UserBlock'
import {
  OpenLeadProfileTab,
  CreateLeadProfileTab,
} from './components/LeadProfileTab/LeadProfileTab'
import FinancialTransactionsReportModal from '@UI/TablePaymentsDiscounts/components/FinancialTransactionsReportModal/FinancialTransactionsReportModal'
import GoalsList from '@common/Goals/GoalsList'
import NotesList from '@common/Notes/NotesList'
import EmailVerifyWrapper from '@common/EmailVerifyWrapper/EmailVerifyWrapper'

const EditStudentModal = (props) => {
  return (
    <div className={classes.modalContainer}>
      <StudentProfileContainer {...props} />
    </div>
  )
}

const StudentProfileContainer = ({
  studentId = null,
  onDismiss = () => {},
  onUpdate = () => {},
  onClickByParent = () => {},
  onClickByLead = () => {},
}) => {
  const addAlert = useAddAlert()
  const profile = useSelector(selectProfile)
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [user, setUser] = useState({})
  const [childrenDirection, setChildrenDirection] = useState([])
  const [userOld, setUserOld] = useState({})
  const [bodyModal, setBodyModal] = useState(null)
  const [actionModal, setActionModal] = useState(null)
  const [recoverPasswordModal, setRecoverPasswordModal] = useState(false)
  const [platformSettings, setSettings] = useState({})

  const constDataModal = {
    state: user,
    setState: setUser,
    close: () => setBodyModal(null),
    setBodyModal,
    addAlert,
  }

  const params = [
    'name',
    'email',
    'phone',
    'sex',
    'birth_date',
    'city',
    'address',
    'education',
    'experience',
    'custom_id',
    'link_to_vk',
    'password',
    'about',
    'notes',
    'about_student',
    'parent_name',
    'parent_phone',
    'parent_telegram',
    'parent_email',
    'parent_whatsapp',
    'roles',
    'learning_class',
    'timezone',
    'url_conference',
    'seminarianDirection',
    'update_vks',
    'parents',
  ]

  const save = async () => {
    setIsLoading(true)
    const data = () => {
      const newData = {}

      for (let key in user) {
        if (params.includes(key)) {
          if (typeof user[key] === 'string') {
            if (user[key]?.length === 0) newData[key] = null
            else newData[key] = user[key]
          } else {
            newData[key] = user[key]
          }
          if ([key] == 'custom_id' && userOld[key] && !user[key])
            newData[key] = null
          if ([key] == 'parents')
            newData[key] = user[key]?.map((child) => child.id)
        }
        if (key === 'birth_date' && user[key]) {
          newData[key] = user[key].replace(/\./g, '-')
        }
      }
      return newData
    }

    usersAPI.upd({ id: user.id, data: data() }).then((res) => {
      if (res.data.status === 'success') {
        addAlert({ title: 'Профиль изменен' })
        onUpdate()
      } else {
        addAlert({
          type: 'error',
          title: 'Упс! Ошибка',
          text:
            res.data?.error?.[0] ??
            'Попробуйте ещё раз или обратитесь к администратору',
        })
      }
      setIsLoading(false)
    })
  }

  const getUser = (withLoader = true) => {
    setIsLoading(withLoader)
    usersAPI
      .getUser({
        id: studentId,
        expand: [
          'userProfile',
          'roles',
          'contracts',
          'workHours',
          'orgUnits.head',
          'teams.head',
          'crmLead',
        ],
      })
      .then((res) => {
        const data = {}
        if (res.data?.id !== undefined)
          for (let key in res.data) {
            if (key === 'userProfile')
              for (let y in res.data.userProfile)
                data[y] = res.data.userProfile[y]
            else data[key] = res.data[key]
          }
        setUser(data)
        setUserOld(data)
        setIsLoading(false)
      })
  }

  const getDirection = () => {
    directionOrdersApi
      .get({
        filter: [`[children_id][eq]=${studentId}`, `[is_disabled][eq]=0`],
        expand: [
          'direction',
          'direction.directionTariffs',
          'group.teacher',
          'privateInfo',
          'teacher',
          'direction.mediaIcon',
        ],
        pageSize: false,
      })
      .then((res) => {
        const directions = (res.data?.data || []).map((direction) =>
          direction.teacher_id
            ? direction
            : { ...direction, teacher: direction.group },
        )

        setChildrenDirection(
          directions.sort(
            (a, b) => Number(!!a.privateInfo) - Number(!!b.privateInfo),
          ),
        )
      })
  }

  useEffect(() => {
    setSettingsFromServer(setSettings)
    getUser()
    getDirection()
  }, [])

  const authorization = () => {
    usersAPI.authorization(user.id).then((response) => {
      AuthService.auth(
        response.data.user,
        response.data.token,
        response.data?.refresh_token,
      )
      window.location.href = '/'
    })
  }

  const changeUserStatus = (status, alert) => {
    // const courses = childrenDirection?.filter(({class_id}) => !class_id) ?? []

    // if(courses?.length > 0){
    //   addAlert({ title: "Нельзя удалить учащегося с активными курсами!", type: 'error' });
    //   return
    // }

    const data = new FormData()
    data.append('ids', JSON.stringify([user.id]))
    data.append('status', status)

    const handleResponse = (res) => {
      if (res.data.status !== 'success') {
        addAlert({
          title: 'Ошибка',
          text: 'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
          type: 'error',
        })
      } else {
        addAlert({ title: alert })
        setUser((prevProfile) => ({
          ...prevProfile,
          status: status,
        }))
        onUpdate()
      }
    }

    const handleError = (error) => {
      addAlert({
        title: 'Ошибка',
        text: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
        type: 'error',
      })
    }

    massActionsApi
      .changeStatus(data)
      .then((res) => handleResponse(res))
      .catch(handleError)
  }

  const handleFooterAction = (action) => {
    switch (action) {
      case 'save':
        save()
        break
      case 'cancel':
        onDismiss()
        break
      case 'resetPassword':
        setRecoverPasswordModal(true)
        //setBodyModal({ type: 'ChangePassword' })
        break
      case 'authorize':
        authorization()
        break
      case 'block':
        setActionModal({
          title: 'Подтвердите действие',
          content: `Вы уверены что хотите заблокировать ${
            user?.name ?? 'учащегося'
          }?`,
          onConfirm: () =>
            changeUserStatus(
              user?.status === 0 ? 10 : 0,
              user?.status === 0
                ? 'Учащийся восстановлен'
                : 'Учащийся заблокирован',
            ),
          onDismiss: () => setActionModal(null),
        })
        break
      case 'delete':
        setActionModal({
          title: 'Подтвердите действие',
          content: `Вы уверены что хотите удалить ${
            user?.name ?? 'учащегося'
          }?`,
          onConfirm: () =>
            changeUserStatus(
              user?.status === 9 ? 10 : 9,
              user?.status === 9 ? 'Учащийся восстановлен' : 'Учащийся удален',
            ),
          onDismiss: () => setActionModal(null),
        })
        break
      default:
        console.log('Unknown action')
    }
  }

  if (isLoading) {
    return (
      <div className={classes.preloaderContainer}>
        <Preloader fullScreen="center" />
      </div>
    )
  }

  return (
    <>
      <div className={classes.studentContentWrapper}>
        <StudentProfileHeader
          platformSettings={platformSettings}
          student={user}
          setUser={setUser}
          setModal={setBodyModal}
        />
        <StudentProfileBody
          platformSettings={platformSettings}
          student={{ ...user, childrenDirection }}
          setUser={setUser}
          setModal={setBodyModal}
          getDirection={getDirection}
          getUser={getUser}
          onClickByParent={onClickByParent}
          onClickByLead={onClickByLead}
        />
        <StudentProfileFooter student={user} onAction={handleFooterAction} />
      </div>
      <Modal
        active={bodyModal != null}
        className={classes.modalWrapperOld}
        setActive={() => setBodyModal(null)}
        classNameBackground={classes.modalBackground}
      >
        <BodyModal
          {...bodyModal}
          {...constDataModal}
          getDirection={() => getDirection()}
        />
      </Modal>
      <Modal
        active={recoverPasswordModal}
        setActive={() => setRecoverPasswordModal(false)}
      >
        {recoverPasswordModal && (
          <ModalContainer closeModal={() => setRecoverPasswordModal(false)}>
            <ModalRecoverPassword
              setActive={() => setRecoverPasswordModal(false)}
              userId={user.id}
            />
          </ModalContainer>
        )}
      </Modal>
      <Modal
        active={actionModal !== null}
        setActive={() => setActionModal(null)}
        className={classes.modalWrapper}
      >
        <ActionModal
          title={actionModal?.title}
          content={actionModal?.content}
          onDismiss={actionModal?.onDismiss}
          onAction={actionModal?.onConfirm}
        />
      </Modal>
    </>
  )
}

const StudentProfileBody = ({
  platformSettings = {},
  student = {},
  setUser = () => {},
  setModal = () => {},
  getDirection = () => {},
  getUser = () => {},
  onClickByParent = () => {},
  onClickByLead = () => {},
}) => {
  const tabItems = [
    {
      label: 'Об учащемся',
      key: 'profile',
      children: (
        <StudentProfileContent
          platformSettings={platformSettings}
          student={student}
          setUser={setUser}
          setModal={setModal}
          getUser={getUser}
          onClickByParent={onClickByParent}
        />
      ),
    },
    {
      label: 'Курсы, классы / Траектории',
      key: 'directions',
      children: (
        <StudentDirectionsContent
          platformSettings={platformSettings}
          student={student}
          setModal={setModal}
          getDirection={getDirection}
        />
      ),
    },
    {
      label: 'Динамика обучения',
      key: 'progress',
      children: <StudentLearningDynamics student={student} />,
    },
  ]

  const hasLead = Array.isArray(student?.crmLead) && student.crmLead.length > 0

  if (hasLead) {
    tabItems.push({
      label: (
        <OpenLeadProfileTab
          onClick={() => onClickByLead(student.crmLead[0]?.id)}
        />
      ),
      key: 'crm-lead',
    })
  } else {
    tabItems.push({
      label: (
        <CreateLeadProfileTab
          student={student}
          onSuccess={() => getUser(false)}
        />
      ),
      key: 'crm-create-lead',
    })
  }

  return (
    <div className={classes.bodyContainer}>
      <Tabs
        className={classes.tabsContainer}
        defaultActiveKey="profile"
        items={tabItems}
      />
    </div>
  )
}

const CourseRow = ({ course, classes, children, onReset }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen(!isOpen)

  return (
    <>
      <div
        className={classNames(
          classes.learningDynamicsRowContainer,
          isOpen && classes.activeCourseRow,
        )}
        onClick={toggleOpen}
        style={{ cursor: 'pointer' }}
      >
        {['course_name', 'start_date', 'end_date', 'status'].map(
          (field, index) => (
            <div
              key={index}
              className={classNames(
                classes.learningDynamicsCell,
                classes.bgPink,
                field === 'status' && classes.justifyCenter,
              )}
            >
              {course[field]}
              {field === 'status' && `${course?.course_progress ?? ''} %`}
              {field === 'course_name' && (
                <div
                  style={{
                    marginLeft: 'auto',
                    transform: isOpen ? 'rotate(0deg)' : 'rotate(90deg)',
                  }}
                >
                  <ArrowListExpand />
                </div>
              )}
            </div>
          ),
        )}
        <div
          className={classNames(
            classes.learningDynamicsExtendedCell,
            classes.justifyCenter,
          )}
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e?.preventDefault()
            e?.stopPropagation()
            onReset()
          }}
        >
          <CloseOutlined />
        </div>
      </div>
      {isOpen && children}
    </>
  )
}

const TopicRow = ({ topic, classes, onReset }) => {
  const getStatusClass = (progress) => {
    if (progress < 75) return classes.bgRed
    if (progress < 90) return classes.bgOrange
    return classes.bgGreen
  }

  return (
    <div className={classes.learningDynamicsExpandedRowContainer}>
      {['topic_name', 'lesson_name', 'start_date', 'end_date', 'progress'].map(
        (field, index) => (
          <div
            key={index}
            className={classNames(
              classes.learningDynamicsExtendedCell,
              (field === 'start_date' ||
                field === 'end_date' ||
                field === 'progress') &&
                classes.justifyCenter,
              field === 'progress' && getStatusClass(topic.progress),
            )}
          >
            {topic[field]}
            {field === 'progress' && '%'}
          </div>
        ),
      )}
      <div
        className={classNames(
          classes.learningDynamicsExtendedCell,
          classes.justifyCenter,
        )}
        style={{ cursor: 'pointer' }}
        onClick={onReset}
      >
        <CloseOutlined />
      </div>
    </div>
  )
}

const TopicHeaderRow = () => (
  <div className={classes.learningDynamicsExpandedRowContainer}>
    <div className={classNames(classes.learningDynamicsCell, classes.bgGray)}>
      Название темы
    </div>
    <div className={classNames(classes.learningDynamicsCell, classes.bgGray)}>
      Название урока
    </div>
    <div className={classNames(classes.learningDynamicsCell, classes.bgGray)}>
      Дата начала
    </div>
    <div className={classNames(classes.learningDynamicsCell, classes.bgGray)}>
      Дата окончания
    </div>
    <div
      className={classNames(
        classes.learningDynamicsCell,
        classes.bgGray,
        classes.justifyCenter,
      )}
    >
      Успех
    </div>
    <div
      className={classNames(
        classes.learningDynamicsExtendedCell,
        classes.justifyCenter,
      )}
    ></div>
  </div>
)

const LearningDynamicsHeaderRow = () => (
  <div className={classes.learningDynamicsRowContainer}>
    <div className={classes.learningDynamicsCell}>Название курса</div>
    <div className={classes.learningDynamicsCell}>Дата начала</div>
    <div className={classes.learningDynamicsCell}>Дата окончания</div>
    <div
      className={classNames(
        classes.learningDynamicsCell,
        classes.justifyCenter,
      )}
    >
      Успех
    </div>
    <div className={classes.learningDynamicsCell}></div>
  </div>
)

const StudentLearningDynamics = ({ student = {} }) => {
  const addAlert = useAddAlert()
  const [learningDynamics, setLearningDynamics] = useState([])
  const [courseToReset, setCourseToReset] = useState(null)
  const [topicToReset, setTopicToReset] = useState(null)

  const fetchDynamic = () => {
    try {
      courseAPI.getLearningDynamics(student?.id).then((res) => {
        setLearningDynamics(res.data.data)
      })
    } catch (error) {
      addAlert({
        title: 'Возникла ошибка при загрузке данных!',
        type: 'error',
      })
    }
  }

  useEffect(() => {
    fetchDynamic()
  }, [student?.id])

  const onCourseReset = async () => {
    try {
      const data = {
        userId: student?.id,
        courseId: courseToReset?.direction?.direction_id,
      }
      const res = await courseAPI.resetCourseLearningDynamic(data)
      if (res?.data?.status === 'success') {
        fetchDynamic()
        addAlert({
          title: 'Статистика по курсу сброшена!',
        })
      }
    } catch (error) {}
    setCourseToReset(null)
  }

  const onTopicReset = async () => {
    try {
      const data = {
        userId: student?.id,
        courseId: topicToReset?.direction_id,
        topicId: topicToReset?.topic?.id,
      }
      const res = await courseAPI.resetTopicLearningDynamic(data)
      if (res?.data?.status === 'success') {
        fetchDynamic()
        addAlert({
          title: 'Статистика сброшена!',
        })
      }
    } catch (error) {}
    setTopicToReset(null)
  }

  return (
    <>
      <div className={classes.learningDynamicsContainer}>
        <LearningDynamicsHeaderRow />
        {learningDynamics.map((course, index) => (
          <CourseRow
            key={index}
            course={course}
            classes={classes}
            onReset={() => setCourseToReset({ direction: course })}
          >
            <TopicHeaderRow />
            {course.topics.map((topic, topicIndex) => (
              <TopicRow
                key={topicIndex}
                student={student}
                topic={topic}
                classes={classes}
                onReset={() =>
                  setTopicToReset({ topic, direction_id: course?.direction_id })
                }
              />
            ))}
          </CourseRow>
        ))}
      </div>
      <Modal
        active={!!topicToReset}
        setActive={() => setTopicToReset(null)}
        className={classes.modalWrapper}
      >
        <ActionModal
          title={'Сбросить статистику'}
          content={`Вы уверены что хотите сбросить статистику по ${topicToReset?.topic?.lesson_name}?`}
          onDismiss={() => setTopicToReset(null)}
          onAction={onTopicReset}
        />
      </Modal>
      <Modal
        active={!!courseToReset}
        setActive={() => setCourseToReset(null)}
        className={classes.modalWrapper}
      >
        <ActionModal
          title={'Сбросить статистику'}
          content={`Вы уверены что хотите сбросить статистику по ${courseToReset?.direction?.course_name}?`}
          onDismiss={() => setCourseToReset(null)}
          onAction={onCourseReset}
        />
      </Modal>
    </>
  )
}

const StudentDepartmentList = ({
  student = {},
  onAddDepartment = () => {},
  onRemoveDepartment = () => {},
}) => {
  const addAlert = useAddAlert()
  const [modal, setModal] = useState(null)

  const errorShow = () => {
    addAlert({
      title: 'Ошибка',
      text: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
      type: 'error',
    })
  }

  const removeFromDepartment = (id) => {
    const departmentName =
      student?.orgUnits?.find((item) => item?.id === modal?.id)?.name ?? '-'

    departments
      .deleteEmployee({
        userId: student?.id,
        unitId: id,
      })
      .then((res) => {
        if (res.data === true) {
          addAlert({
            text: `${student?.name} исключен из отдела ${departmentName}!`,
          })
          onRemoveDepartment()
        } else {
          errorShow()
        }
      })
  }

  const addToDepartment = (department) => {
    departments
      .addAnEmployeeToDepartment({
        userId: [student?.id],
        unitId: department?.id,
      })
      .then((res) => {
        if (res.data) {
          onAddDepartment()
          addAlert({
            text: `${student?.name} добавлен в отдел ${department?.name}!`,
          })
        } else {
          errorShow()
        }
      })
  }

  return (
    <>
      <div className={classes.studentsDepartmentsWrapper}>
        <div className={classes.studentsDepartmentsRow}>
          <div className={classes.studentsDepartmentsHeaderCell}>Отдел</div>
          <div className={classes.studentsDepartmentsHeaderCell}>
            Руководитель
          </div>
          <div
            className={classNames(
              classes.studentsDepartmentsHeaderCell,
              classes.studentsDepartmentsHeaderCellAction,
            )}
          >
            <Button
              newDesign
              className={classNames(
                classes.secondaryButton,
                classes.truncateText,
                classes.textSemiBold,
              )}
              action={() => {
                setModal({ type: 'add-department' })
              }}
            >
              Добавить отдел
            </Button>
          </div>
        </div>
        {!student?.orgUnits && (
          <div className={classes.departmentsRowStub}>Отделов нет</div>
        )}
        {student?.orgUnits?.map((item, index) => {
          return (
            <div key={index} className={classes.studentsDepartmentsRow}>
              <div className={classes.studentsDepartmentsCell}>
                {item?.name ?? '-'}
              </div>
              <div className={classes.studentsDepartmentsCell}>
                {item?.head?.name ?? '-'}
              </div>
              <div
                className={classNames(
                  classes.studentsDepartmentsCell,
                  classes.studentsDepartmentsHeaderCellAction,
                )}
              >
                <Button
                  newDesign
                  className={classNames(
                    classes.ternaryButton,
                    classes.truncateText,
                    classes.textSemiBold,
                  )}
                  action={() => {
                    setModal({ type: 'remove-department', id: item?.id })
                  }}
                >
                  Исключить
                </Button>
              </div>
            </div>
          )
        })}
      </div>
      <Modal
        active={modal !== null}
        setActive={() => setModal(null)}
        className={classes.modalWrapper}
      >
        {modal?.type === 'remove-department' && (
          <ActionModal
            title={'Исключить из отдела'}
            content={`Вы уверены что хотите исключить ${
              student?.name
            } из отдела ${
              student?.orgUnits?.find((item) => item?.id === modal?.id).name
            }?`}
            onDismiss={() => setModal(null)}
            onAction={() => {
              removeFromDepartment(modal?.id)
              setModal(null)
            }}
          />
        )}
        {modal?.type === 'add-department' && (
          <SelectDepartmentModal
            title={'Добавить к отделу'}
            onDismiss={() => setModal(null)}
            onSelect={(department) => {
              if (department === null) {
                addAlert({
                  title: 'Нужно выбрать отдел для продолжения!',
                })
                return
              }
              addToDepartment(department)
              setModal(null)
            }}
          />
        )}
      </Modal>
    </>
  )
}

const StudentDocksList = ({
  student = {},
  onAddDock = () => {},
  onDeleteDock = () => {},
}) => {
  const [viewAll, setViewAll] = useState(false)

  const contractsToShow = viewAll
    ? student?.contracts
    : student?.contracts?.slice(0, 3)

  return (
    <div className={classes.containerStudentDocks}>
      <div className={classes.containerStudentDocksList}>
        <div className={classes.docksListItemContainer}>
          <div className={classes.docksListHeader}>
            <div className={classes.textSemiBold}>Название договора</div>
            <div
              style={{ textAlign: 'center' }}
              className={classes.textSemiBold}
            >
              Файл
            </div>
          </div>
          <Button
            newDesign
            className={classNames(
              classes.secondaryButton,
              classes.truncateText,
              classes.textSemiBold,
            )}
            onClick={onAddDock}
          >
            Добавить договор
          </Button>
        </div>
        {contractsToShow?.map((dock, index) => {
          return (
            <div className={classes.docksListItemContainer} key={index}>
              <div className={classes.docksListItem}>
                <div>{dock.name}</div>
                <a
                  className={classNames(
                    classes.secondaryButton,
                    classes.truncateText,
                    classes.fillMinWidth,
                  )}
                  style={{ justifyContent: 'center' }}
                  href={process.env.REACT_APP_PATH_FILE + dock.file_path}
                  target="_blank"
                  rel="noreferrer"
                >
                  Файл загружен
                </a>
              </div>
              <div className={classes.deleteDockButtonWrapper}>
                <div
                  className={classes.deleteDockButton}
                  onClick={() => onDeleteDock(dock)}
                >
                  <IcoRemove />
                </div>
              </div>
            </div>
          )
        })}
      </div>
      {student?.contracts?.length > 3 && (
        <Button
          newDesign
          className={classNames(classes.secondaryButton, classes.truncateText)}
          onClick={() => setViewAll(!viewAll)}
        >
          {viewAll ? 'скрыть' : 'смотреть еще'}
        </Button>
      )}
    </div>
  )
}

const DirectionDescription = ({ title, value }) => (
  <div className={classes.directionDescriptionWrapper}>
    <div className={classes.directionDescriptionTitle}>{title}</div>
    <div
      className={classNames(classes.inputSmallContainer, classes.truncateText)}
    >
      {value}
    </div>
  </div>
)

const DirectionAdditionalDescription = ({ title, value }) => (
  <div className={classes.directionAdditionalDescriptionWrapper}>
    <div
      className={classNames(
        classes.directionAdditionalDescriptionTitle,
        classes.truncateText,
      )}
    >
      {title}
    </div>
    <div className={classes.inputSmallContainer}>
      <div className={classes.directionAdditionalDescriptionTitle}>{value}</div>
    </div>
  </div>
)

const StudentDirectionsContent = ({
  platformSettings = {},
  student = {},
  setModal = () => {},
  getDirection = () => {},
}) => {
  const userIdsAllowedToDeleteCourses =
    platformSettings?.userIdsAllowedToDeleteCourses
      ? JSON.parse(platformSettings?.userIdsAllowedToDeleteCourses)
      : []
  const selectEmployeesWhoAreAllowedDeleteCourses =
    platformSettings?.selectEmployeesWhoAreAllowedDeleteCourses === '1'

  const profile = useSelector(selectProfile)

  const addAlert = useAddAlert()
  const [directionOrders, setDirectionOrders] = useState([])
  const [privateInfo, setPrivateInfo] = useState([])
  const [userClasses, setUserClasses] = useState([])
  const [modalRemoveClass, setModalRemoveClass] = useState({
    active: false,
    data: {},
  })
  const [modalDetachGroup, setModalDetachGroup] = useState({
    isOpen: false,
  })

  const fetchClasses = () => {
    classApi.showByUser(student.id).then(({ data }) => {
      setUserClasses(data?.data ?? [])
    })
  }

  useEffect(() => {
    fetchClasses()
  }, [student.id])

  useEffect(() => {
    const newPrivateInfo = []
    student.childrenDirection?.forEach(
      (order) => order?.privateInfo?.id && newPrivateInfo.push(order),
    )
    setPrivateInfo(newPrivateInfo)
  }, [student.childrenDirection])

  useEffect(() => {
    setDirectionOrders(
      student?.childrenDirection?.filter(({ class_id }) => !class_id) ?? [],
    )
  }, [student.childrenDirection])

  const getTariff = (item) =>
    item?.direction?.directionTariffs?.find(
      (tariff) => tariff.id === item.tariff_id,
    )

  const handleAttachClass = () => {
    setModal({
      type: 'AddClass',
      data: {
        selected: student.childrenDirection
          ?.filter(({ class_id }) => userClasses.find((c) => c.id === class_id))
          ?.map(({ class_id }) => class_id),
        onSuccess: () => {
          getDirection()
          fetchClasses()
        },
        onError: ({ data }) =>
          addAlert({
            type: 'error',
            title: 'Не удалось добавить класс',
            // text: Object.entries(data.data)[0][1] || ''
          }),
      },
    })
  }

  const handleDetachGroup = (group, elClass) => {
    setModalDetachGroup({
      isOpen: true,
      text: `Вы действительно хотите удалить ученика из группы "${group.name}"?`,
      onConfirm: () => {
        classApi
          .detachUserClassGroup(elClass.id, {
            direction_group_id: group.id,
            user_id: student.id,
          })
          .then(() => {
            getDirection()
            fetchClasses()
          })
        setModalDetachGroup((prev) => {
          return { isOpen: false }
        })
      },
      onDismiss: () => {
        setModalDetachGroup((prev) => {
          return { isOpen: false }
        })
      },
    })
  }

  const handleAttachGroup = (elClass) => {
    setModal({
      type: 'AddGroupToClass',
      data: {
        classId: elClass.id,
        selected: student.childrenDirection
          ?.filter(({ class_id }) => class_id === elClass.id)
          ?.map(({ direction_id }) => direction_id),
        filterByDirection: true,
        onSuccess: () => {
          getDirection()
          fetchClasses()
        },
        onError: ({ data }) =>
          addAlert({
            type: 'error',
            title: 'Не удалось добавить группу',
            text: Object.entries(data.data)[0][1] || '',
          }),
      },
    })
  }

  const handleDetachClass = (elClass) => {
    openModalRemoveClass({
      user_id: student.id,
      elClass: elClass,
    })
  }

  const closeModalRemoveClass = () => {
    setModalRemoveClass({ active: false, data: {} })
  }
  const openModalRemoveClass = (data) => {
    setModalRemoveClass({ active: true, data })
  }

  const profileSettings = useSelector((store) => store.settings)

  return (
    <div className={classes.bodyContent}>
      <div
        className={classes.cardContainer}
        style={{
          display: toBoolean(platformSettings?.isShowCoursesChild ?? true)
            ? 'auto'
            : 'none',
        }}
      >
        <div className={classes.headerCoursesContainer}>
          <div className={classes.headerTitleDirection}>Курсы</div>
          <Button
            newDesign
            className={classNames(
              classes.primaryButton,
              classes.truncateText,
              classes.fontWeight500,
            )}
            onClick={() => {
              setModal({
                type: 'AddDirection',
                data: {
                  directions: directionOrders?.map(
                    ({ direction_id }) => direction_id,
                  ),
                },
              })
            }}
          >
            Добавить курс
          </Button>
        </div>
        {directionOrders?.length > 0 && (
          <div className={classes.directionList}>
            {directionOrders?.map((direction, index) => {
              const tariffType = getTariff(direction)?.type

              return (
                <div className={classes.directionListItem} key={index}>
                  <div className={classes.directionListItemWrapper}>
                    <div className={classes.directionListItemHeaderInfo}>
                      <div className={classes.directionInfoContainer}>
                        <DirectionDescription
                          title="Название"
                          value={direction?.direction?.name ?? 'Названия нет'}
                        />
                        <DirectionDescription
                          title="Тариф"
                          value={getTariff(direction)?.name}
                        />
                        <DirectionDescription
                          title="Группа/Педагог"
                          value={`${direction?.group?.name ?? ''} ${
                            getTariff(direction)?.any_seminarian
                              ? 'Любой учитель'
                              : direction.group_id
                              ? direction?.group?.teacher?.name ??
                                'Не распределено'
                              : direction?.teacher?.name ?? 'Не распределено'
                          }`}
                        />
                        {![
                          'hour',
                          'minute',
                          'free',
                          'stream_one_time',
                        ].includes(tariffType) && (
                          <CourseDiscountField
                            order={direction}
                            user={student}
                            onUpdate={getDirection}
                          />
                        )}
                        {tariffType === 'free' && (
                          <div
                            className={classNames(
                              classes.smallFieldWrapper,
                              classes.extraDescription,
                            )}
                          >
                            Бесплатный
                          </div>
                        )}
                        {tariffType === 'stream_one_time' && (
                          <div
                            className={classNames(
                              classes.smallFieldWrapper,
                              classes.extraDescription,
                            )}
                          >
                            Доступ навсегда
                          </div>
                        )}
                        {/* {![
                          'free',
                          'minute',
                          'hour',
                          'stream_one_time',
                        ].includes(getTariff(direction)?.type) && (
                          <CoursePriceField
                            order={direction}
                            user={student}
                            onUpdate={getDirection}
                          />
                        )} */}
                      </div>
                      <div className={classes.directionItemActions}>
                        {direction?.privateInfo?.salary_per_hour && (
                          <div
                            onClick={() => {
                              setModal({
                                type: 'AddDirection',
                                data: {
                                  directions: directionOrders
                                    ?.map(({ direction_id }) => direction_id)
                                    .filter(
                                      (el) => el !== direction.direction_id,
                                    ),
                                  item: privateInfo?.find(
                                    (el) => direction.id === el.id,
                                  ),
                                },
                              })
                            }}
                            className={classes.secondaryIcon}
                          >
                            <IcoEdit />
                          </div>
                        )}
                        {(userIdsAllowedToDeleteCourses.includes(profile.id) ||
                          !selectEmployeesWhoAreAllowedDeleteCourses) && (
                          <div
                            onClick={() => {
                              setModal({
                                type: 'RemoveDirection',
                                data: direction.id,
                              })
                            }}
                            className={classes.secondaryIcon}
                          >
                            <IcoRemove />
                          </div>
                        )}
                      </div>
                    </div>
                    {direction?.status_payment !== 1 && (
                      <span
                        className={
                          classes.directionPaymentMessageDescriptionAlert
                        }
                      >
                        Пока не оплачено
                      </span>
                    )}
                    {dayjs(direction?.next_payment_date).isValid() &&
                      !['free', 'stream_one_time', 'hour', 'minute'].includes(
                        tariffType,
                      ) && (
                        <span
                          className={classes.directionPaymentMessageDescription}
                        >
                          Оплачено до{' '}
                          {dayjs(direction?.next_payment_date).format(
                            'DD.MM.YYYY',
                          )}
                        </span>
                      )}
                  </div>
                  {direction?.privateInfo?.salary_per_hour && (
                    <div className={classes.directionAdditionalInfoContainer}>
                      <DirectionAdditionalDescription
                        title="Кол-во в неделю"
                        value={direction?.privateInfo?.lessons_per_week ?? '-'}
                      />
                      <DirectionAdditionalDescription
                        title={`Длительность/${
                          tariffType === 'minute' ? 'минут' : 'час'
                        }`}
                        value={
                          Math.ceil(
                            parseFloat(
                              (tariffType === 'minute'
                                ? direction?.privateInfo?.time_one_lesson * 60
                                : direction?.privateInfo?.time_one_lesson
                              ).toFixed(2),
                            ),
                          ) ?? '-'
                        }
                      />
                      <DirectionAdditionalDescription
                        title={`Цена/${
                          tariffType === 'minute' ? 'минута' : 'час'
                        }`}
                        value={
                          direction?.privateInfo?.hour_cost
                            ? direction?.privateInfo?.hour_cost + ' руб.'
                            : '-'
                        }
                      />
                      <DirectionAdditionalDescription
                        title={`Педагог/${
                          tariffType === 'minute' ? 'минута' : 'час'
                        }`}
                        value={
                          direction?.privateInfo?.salary_per_hour
                            ? direction?.privateInfo?.salary_per_hour + ' руб.'
                            : '-'
                        }
                      />
                      <DirectionAdditionalDescription
                        title="Баланс"
                        value={`${
                          tariffType === 'minute'
                            ? Math.floor(direction?.buy_hours ?? 0)
                            : Number(direction?.buy_hours ?? 0).toFixed(2)
                        } ${tariffType === 'minute' ? 'минут' : 'часов'}`}
                      />
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
      <div
        className={classes.trajectoryWrapper}
        style={{
          display: toBoolean(platformSettings?.isShowClassesChild ?? true)
            ? 'auto'
            : 'none',
        }}
      >
        <div className={classes.trajectoryWrapperHeader}>
          <div className={classes.headerTitleDirection}>
            Классы / Обр.траектории
          </div>
          <Button
            newDesign
            className={classNames(
              classes.primaryButton,
              classes.truncateText,
              classes.primaryButtonV1,
              classes.fontWeight500,
            )}
            onClick={() => handleAttachClass()}
          >
            Добавить класс/траекторию
          </Button>
        </div>
        {userClasses?.map((userClass, index) => {
          const isShowPayments = userClass?.classUser?.amount !== null
          return (
            <div
              className={classNames(
                classes.cardContainer,
                classes.directionCard,
              )}
              key={index}
            >
              <div className={classes.trajectoryItemHeader}>
                <div
                  className={classNames(
                    classes.headerTitleDirection,
                    classes.maxWidth150,
                    classes.truncateText,
                  )}
                >
                  {userClass?.title}
                </div>
                {isShowPayments && (
                  <>
                    <div className={classes.headerTitleDirectionPaid}>
                      {userClass?.classUser?.status_payment === 1 ? (
                        'Оплачено до: '
                      ) : (
                        <>
                          <span style={{ color: 'var(--color-accent-first)' }}>
                            Пока не оплачено.
                          </span>{' '}
                          До:{' '}
                        </>
                      )}
                      <Moment
                        date={userClass.classUser.next_payment_date}
                        format="DD MM YYYY"
                        withTitle
                      />
                    </div>
                    <ClassDiscountField
                      user={student}
                      userClass={userClass}
                      onUpdate={fetchClasses}
                    />
                    <ClassPriceField
                      user={student}
                      userClass={userClass}
                      onUpdate={fetchClasses}
                    />
                  </>
                )}
              </div>
              <div className={classes.classesListContainer}>
                <div className={classes.directionCourseItem} key={index}>
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Курс
                  </div>
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Тариф
                  </div>
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Группа
                  </div>
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Преподаватель
                  </div>
                </div>
                {student.childrenDirection
                  ?.filter((el) => el.class_id == userClass?.id)
                  ?.map((el) => {
                    return (
                      <CourseInClass
                        key={el.id}
                        name={el.direction?.name}
                        tariffName={
                          el.direction?.directionTariffs?.find(
                            (tariff) => tariff.id === el.tariff_id,
                          )?.name
                        }
                        directionId={el.direction.id}
                        directionOrderId={el.id}
                        group={el?.group}
                        getDirection={getDirection}
                        fetchClasses={fetchClasses}
                        seminarianName={el?.group?.teacher_name}
                        userIdsAllowedToDeleteCourses={
                          userIdsAllowedToDeleteCourses
                        }
                        selectEmployeesWhoAreAllowedDeleteCourses={
                          selectEmployeesWhoAreAllowedDeleteCourses
                        }
                        profile={profile}
                        handleDetachGroup={handleDetachGroup}
                        userClass={userClass}
                        index={index}
                      />
                    )
                  })}
                {/* {userClass?.groups
                  ?.filter((group) =>
                    student.childrenDirection?.find(
                      (order) => order.group_id === group.id,
                    ),
                  )
                  ?.map((group, index) => {
                    console.log(userClass?.groups)
                    console.log(student.childrenDirection)
                    return (
                      <CourseInClass
                        name = {group.direction?.name}
                        tariffName = {
                          group.direction?.tariffs?.find(
                            (tariff) => tariff.id === group.tariff_id,
                            )?.name
                        }
                        directionId={group.direction.id}
                        directionOrderId={group.direction_order_id}
                        group = {group}
                        getDirection={getDirection}
                        fetchClasses={fetchClasses}
                        seminarianName={group?.seminarian?.name}
                        userIdsAllowedToDeleteCourses={userIdsAllowedToDeleteCourses}
                        selectEmployeesWhoAreAllowedDeleteCourses={selectEmployeesWhoAreAllowedDeleteCourses}
                        profile={profile}
                        handleDetachGroup={handleDetachGroup}
                        userClass={userClass}
                        index={index}
                      />
                    )
                  })} */}
              </div>
              <div className={classes.classActionContainer}>
                <Button
                  newDesign
                  className={classNames(
                    classes.primaryButton,
                    classes.truncateText,
                    classes.fontWeight500,
                  )}
                  onClick={() => handleAttachGroup(userClass)}
                >
                  Добавить группу
                </Button>
                {(userIdsAllowedToDeleteCourses.includes(profile.id) ||
                  !selectEmployeesWhoAreAllowedDeleteCourses) && (
                  <Button
                    newDesign
                    className={classNames(
                      classes.primaryButton,
                      classes.truncateText,
                      classes.fontWeight500,
                      classes.errorButton,
                    )}
                    onClick={() => handleDetachClass(userClass)}
                  >
                    Удалить класс
                  </Button>
                )}
              </div>
            </div>
          )
        })}
      </div>
      <Modal active={modalRemoveClass.active} setActive={closeModalRemoveClass}>
        <ModalContainer closeModal={closeModalRemoveClass}>
          <ModalRemoveClass
            closeModal={closeModalRemoveClass}
            elClass={modalRemoveClass.data.elClass}
            user_id={modalRemoveClass.data.user_id}
            setClasses={setUserClasses}
            fetchClasses={fetchClasses}
          />
        </ModalContainer>
      </Modal>
      <Modal
        active={modalDetachGroup?.isOpen}
        setActive={() => setModalDetachGroup({ isOpen: false })}
        className={classes.modalWrapper}
      >
        <ActionModal
          title={'Вы точно хотите открепить курс'}
          content={modalDetachGroup?.text}
          onDismiss={modalDetachGroup?.onDismiss}
          onAction={modalDetachGroup?.onConfirm}
        />
      </Modal>
    </div>
  )
}

const ChangeGroupCell = ({
  selectedGroup,
  directionId,
  directionOrderId,
  refetchData,
  className,
}) => {
  const addAlert = useAddAlert()

  const [groupsState, doFetchGroups] = useAsyncFn(
    async () =>
      await directionGroupApi.get({
        filter: ['[direction_id]=' + directionId],
      }),
    [],
  )
  const allGroupsData = groupsState.value?.data ?? []
  const options = allGroupsData
    ?.map((g) => ({
      label: g.name,
      value: g.id,
    }))
    ?.filter((item) => item.value !== selectedGroup?.id) // Удаляем выбранный, если есть (чтобы добавить его в начало)
    ?.sort((a, b) => (a.label > b.label ? 1 : -1))

  if (!!selectedGroup?.id) {
    options.unshift({
      label: selectedGroup.name,
      value: selectedGroup.id,
    })
  }

  const handlerChangeGroup = (newGroupId) => {
    ModalAnt.confirm({
      title: 'Вы уверены что хотите перевести ученика?',
      content: `В группу "${
        allGroupsData.find((g) => g.id === newGroupId)?.name ?? '(без названия)'
      }"`,
      icon: null,
      centered: true,
      maskClosable: true,
      className: jclasses.modal,
      okText: 'Подтвердить',
      cancelText: 'Отменить',
      onOk: () => {
        directionGroupApi
          .moveStudentsToGroup({
            direction_orders_ids: [directionOrderId],
            new_group_id: newGroupId,
          })
          .then((res) => {
            if (isError(res)) throw new Error()

            addAlert({
              title: 'Успех',
              text: 'Студент успешно переведён',
              type: 'success',
            })

            refetchData && refetchData()
          })
          .catch(() => {
            addAlert({
              title: 'Ошибка',
              text: 'Ошибка перевода студента',
              type: 'error',
            })
          })
      },
    })
  }

  return (
    <SelectAnt
      className={classNames(iclasses.newSelect, className)}
      popupClassName={iclasses.newSelectPopup}
      placeholder="Выберите группу"
      suffixIcon={<EditOutlined />}
      options={options}
      value={selectedGroup?.id}
      onChange={handlerChangeGroup}
      onClick={() => doFetchGroups()}
      loading={groupsState.loading}
    />
  )
}

const StudentProfileContent = ({
  platformSettings = {},
  student = {},
  setUser = () => {},
  setModal = () => {},
  getUser = () => {},
  onClickByParent = () => {},
}) => {
  const addAlert = useAddAlert()
  const dateFormat = 'YYYY.MM.DD'

  const [generalSettings, setGeneralSettings] = useState({})
  useEffect(() => {
    setSettingsFromServer(setGeneralSettings)
  }, [])
  const hideParentsData = generalSettings?.hideParentsData == 1

  const handleChange = (event, field) => {
    const value = event.target.value
    setUser((prevProfile) => ({
      ...prevProfile,
      [field]: value,
    }))
  }

  const updateNumberSettings = (event, field, min, max, empty = false) => {
    const value = event.target.value
    if (empty && !value) {
      setUser((prevProfile) => ({
        ...prevProfile,
        [field]: '',
      }))
      return
    }
    const percent = Number(value)
    if (Number.isInteger(percent) && percent <= max && percent >= min) {
      setUser((prevProfile) => ({
        ...prevProfile,
        [field]: value,
      }))
    }
  }

  const updateUser = (value, field) => {
    setUser((prevProfile) => ({
      ...prevProfile,
      [field]: value,
    }))
  }

  const birthDate = student?.birth_date
    ? dayjs(student?.birth_date.replace(/-/gi, '.'), dateFormat)
    : dayjs('2000.01.01'.replace(/-/gi, '.'), dateFormat)

  const parents = Array.isArray(student.parents) ? student.parents : []

  const setParents = (parents) => {
    setUser((prevProfile) => ({
      ...prevProfile,
      parents,
    }))
  }

  const deleteParent = (id) => {
    setParents(parents.filter((parent) => parent.id !== id))
  }

  const [parentsModal, setParentsModal] = useState(false)

  return (
    <div className={classes.bodyContent}>
      <div className={classes.gridContainerMainInfo}>
        {toBoolean(platformSettings?.isShowPhoneChild ?? true) && (
          <input
            className={classes.inputSmallContainer}
            value={student?.phone ?? ''}
            onChange={(e) => handleChange(e, 'phone')}
            placeholder="Телефон"
          />
        )}
        {toBoolean(platformSettings?.isShowEmailChild ?? true) && (
          <EmailVerifyWrapper
            visible={platformSettings?.requireStudentEmailConfirmation === '1'}
            verified={student?.is_email_confirmed === 1}
            style={{ width: 'auto' }}
          >
            <input
              className={classes.inputSmallContainer}
              value={student?.email ?? ''}
              onChange={(e) => handleChange(e, 'email')}
              placeholder="Почта"
            />
          </EmailVerifyWrapper>
        )}
        {toBoolean(platformSettings?.isShowGenderChild ?? true) && (
          <Select
            newDesign
            className={classes.inputSmallContainer}
            options={[
              { label: 'Муж', value: 'male' },
              { label: 'Жен', value: 'female' },
            ]}
            title={
              student?.sex ? (student?.sex === 'male' ? 'Муж' : 'Жен') : 'Пол'
            }
            onChange={(e) => updateUser(e.value, 'sex')}
          />
        )}
        {toBoolean(platformSettings?.isShowDateOfBirthChild ?? true) && (
          <DatePicker
            onChange={(date, dateString) => {
              updateUser(dateString, 'birth_date')
            }}
            value={birthDate}
            format={dateFormat}
            className={classes.inputSmallContainer}
          />
        )}
        {toBoolean(platformSettings?.isShowCityChild ?? true) && (
          <input
            className={classes.inputSmallContainer}
            value={student?.city ?? ''}
            onChange={(e) => handleChange(e, 'city')}
            placeholder="Город"
          />
        )}
      </div>
      <div className={classes.gridContainerSecondaryInfo}>
        {toBoolean(platformSettings?.isShowPromoChild ?? true) && (
          <div
            className={classNames(
              classes.inputSmallContainer,
              student?.promo_code ?? classes.inputPlaceholderText,
            )}
          >
            {student?.promo_code ?? 'Промокод'}
          </div>
        )}
        {toBoolean(platformSettings?.isShowIdChild ?? true) && (
          <div className={classes.inputSmallContainer}>
            {`ID: ${student?.id}`}
          </div>
        )}
        {toBoolean(platformSettings?.isShowPointerChild ?? true) && (
          <Tooltip
            placement="topLeft"
            title={
              'В это поле вы можете добавить любую информацию. Она всегда будет отображаться рядом с ФИО учащегося'
            }
          >
            <input
              className={classes.inputSmallContainer}
              value={student?.custom_id ?? ''}
              onChange={(e) => handleChange(e, 'custom_id')}
              placeholder="Указатель"
            />
          </Tooltip>
        )}
        {toBoolean(
          platformSettings?.isShowLinkToSocialMediaNetChild ?? true,
        ) && (
          <input
            className={classes.inputSmallContainer}
            value={student?.link_to_vk ?? ''}
            onChange={(e) => handleChange(e, 'link_to_vk')}
            placeholder="Ссылка на соц.сети"
          />
        )}
        {toBoolean(platformSettings?.isShowClassChild ?? true) && (
          <input
            className={classes.inputSmallContainer}
            value={student?.learning_class ?? ''}
            onChange={(e) =>
              updateNumberSettings(e, 'learning_class', 0, 10000, true)
            }
            placeholder="Класс"
          />
        )}
      </div>
      {(toBoolean(platformSettings?.isShowAboutMeChild ?? true) ||
        toBoolean(platformSettings?.isShowAboutChild ?? true)) && (
        <div className={classes.containerAboutStudentInfo}>
          {toBoolean(platformSettings?.isShowAboutMeChild ?? true) && (
            <ContainerWithHeader title="О себе (заполняет уч.):">
              <textarea
                className={classes.inputTextAreaContainer}
                rows="3"
                value={student?.about ?? ''}
                onChange={(e) => handleChange(e, 'about')}
                placeholder="Информация о себе"
              />
            </ContainerWithHeader>
          )}
          {toBoolean(platformSettings?.isShowAboutChild ?? true) && (
            <ContainerWithHeader title="Об учащемся:">
              <textarea
                className={classes.inputTextAreaContainer}
                rows="3"
                value={student?.about_student ?? ''}
                onChange={(e) => handleChange(e, 'about_student')}
                placeholder="Информация об учащимся, которую он не видит"
              />
            </ContainerWithHeader>
          )}
        </div>
      )}
      {toBoolean(platformSettings?.isEnabledGoalsAndNotes ?? true) && (
        <div className={classes.containerNotesAndGoals}>
          <ContainerWithHeader title="Мои цели">
            <GoalsList userId={student?.id} />
          </ContainerWithHeader>
          <ContainerWithHeader title="Мои заметки">
            <NotesList userId={student?.id} />
          </ContainerWithHeader>
        </div>
      )}
      <div style={hideParentsData ? { display: 'none' } : { display: 'auto' }}>
        {(toBoolean(platformSettings?.isShowParentNameChild ?? true) ||
          toBoolean(platformSettings?.isShowParentEmailChild ?? true) ||
          toBoolean(platformSettings?.isShowParentPhoneChild ?? true)) && (
          <ContainerWithHeader title="Родители:">
            {parents.map((user) => (
              <UserBlock
                user={user}
                deleteUser={deleteParent}
                onClickByUser={onClickByParent}
              />
            ))}
            <Button
              newDesign
              className={classNames(
                classes.secondaryButton,
                classes.truncateText,
                classes.textSemiBold,
              )}
              onClick={() => setParentsModal(true)}
              style={{ width: 'fit-content' }}
            >
              Привязать родителя
            </Button>
            <Modal
              active={parentsModal}
              className={classes.modalWrapperOld}
              setActive={() => setParentsModal(false)}
              classNameBackground={classes.modalBackground}
            >
              <ModalContainer closeModal={() => setParentsModal(false)}>
                <UserSearch
                  selectUsers={parents}
                  setSelectUser={setParents}
                  closeModal={() => setParentsModal(false)}
                  roleSeach="parent"
                />
              </ModalContainer>
            </Modal>
            {/* <div className={classes.containerAboutStudentParentsInfo}>
              {toBoolean(platformSettings?.isShowParentNameChild ?? true) && (
                <input
                  className={classes.inputSmallContainer}
                  value={student?.parent_name ?? ''}
                  onChange={(e) => handleChange(e, 'parent_name')}
                  placeholder="Ф.И.О. родителя"
                />
              )}
              {toBoolean(platformSettings?.isShowParentEmailChild ?? true) && (
                <input
                  className={classes.inputSmallContainer}
                  value={student?.parent_email ?? ''}
                  onChange={(e) => handleChange(e, 'parent_email')}
                  placeholder="Почта"
                />
              )}
              {toBoolean(platformSettings?.isShowParentPhoneChild ?? true) && (
                <input
                  className={classes.inputSmallContainer}
                  value={student?.parent_phone ?? ''}
                  onChange={(e) => handleChange(e, 'parent_phone')}
                  placeholder="телефон"
                />
              )}
              <input
                className={classes.inputSmallContainer}
                value={student?.parent_telegram ?? ''}
                onChange={(e) => handleChange(e, 'parent_telegram')}
                placeholder="Ссылка на соц.сеть"
              />
            </div> */}
          </ContainerWithHeader>
        )}
      </div>
      <ContainerWithHeader title="Отделы:">
        <StudentDepartmentList
          student={student}
          onAddDepartment={() => {
            getUser(false)
          }}
          onRemoveDepartment={() => {
            getUser(false)
          }}
        />
      </ContainerWithHeader>
      {toBoolean(platformSettings?.isShowAgreementsChild ?? true) && (
        <ContainerWithHeader title="Договора:">
          <StudentDocksList
            student={student}
            onAddDock={() => setModal({ type: 'AddContract' })}
            onDeleteDock={(dock) =>
              setModal({ type: 'RemoveContract', data: dock?.id })
            }
          />
        </ContainerWithHeader>
      )}
    </div>
  )
}

const ContainerWithHeader = ({ title, children }) => {
  return (
    <div className={classes.containerWithHeader}>
      <div className={classes.containerWithHeaderTitle}>{title}</div>
      {children}
    </div>
  )
}

const StudentProfileHeader = ({
  platformSettings = {},
  student = {},
  setUser = () => {},
  setModal = () => {},
}) => {
  const isUniversalBalance = platformSettings?.isUniversalBalance === '1'
  const [isModalHistory, setIsModalHistory] = useState(false)

  return (
    <>
      <div className={classes.headerContainer}>
        <div className={classes.userAvatarContainer}>
          <img
            className={classes.userAvatar}
            src={getAvatar(student)}
            alt={student?.name}
          />
          <div className={classes.userAvatarEditIconWrapper}>
            <EditIcoNewDesign
              className={classes.userAvatarEditIcon}
              onClick={() => setModal({ type: 'Ava' })}
            />
          </div>
        </div>
        <div className={classes.userHeaderInfoContainer}>
          <div className={classes.userHeaderNameContainer}>
            <span className={classes.truncateText}>{student?.name}</span>
            <EditIcoNewDesign
              className={classes.editIcon}
              onClick={() => setModal({ type: 'Name' })}
            />
          </div>
          <div className={classes.subheaderContainer}>
            <div className={classes.userHeaderLastActiveContainer}>
              <div className={classes.userHeaderLastActiveDot} />
              <span className={classes.truncateText}>
                {formatLastActionTime(student?.last_login)}
              </span>
            </div>
            {isUniversalBalance && (
              <div className={classes.balance}>
                Баланс:
                <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                  {student.balance + '₽'}
                </span>
                |
                <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                  {Number(student.balance_euro).toFixed(2) + '€'}
                </span>
                |
                <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                  {Number(student.balance_dollar).toFixed(2) + '$'}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={classes.userHeaderRightContainer}>
          <Button
            newDesign
            className={classNames(classes.primaryButton, classes.truncateText)}
            onClick={() => setIsModalHistory(true)}
          >
            История списаний и начислений
          </Button>
          <div className={classes.inputSmallContainer}>
            <span className={classes.truncateText}>
              {`Дата регистрации: ${formatTimestampDate(student?.created_at)}`}
            </span>
          </div>
        </div>
      </div>
      <FinancialTransactionsReportModal
        userId={student.id}
        open={isModalHistory}
        onClose={() => setIsModalHistory(false)}
      />
    </>
  )
}

const ClassDiscountField = ({ user, userClass, onUpdate }) => {
  const addAlert = useAddAlert()
  const defaultValue = Number(userClass?.classUser?.discount ?? 0)
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const saveDiscount = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить скидку',
      })
    }

    let params = {
      class_id: userClass?.id,
      discount: Number(fieldValue),
      discount_currency: 'rub',
      user_id: user.id,
    }

    classApi
      .changeDiscountForChild(params)
      .then((e) => {
        if (e.data.error) {
          onError()
        } else {
          addAlert({
            title: 'Скидка обновлена',
          })
          onUpdate()
        }
      })
      .catch((e) => {
        onError()
      })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      Скидка
      <div className={classes.smallFieldWrapper}>
        <input
          className={classNames(
            classes.inputSmallWithTrailingIcon,
            classes.directionAdditionalDescriptionTitle,
          )}
          value={fieldValue}
          placeholder="0"
          type="number"
          onChange={handleChange}
        />
        <div className={classes.directionAdditionalDescriptionTitle}>руб.</div>
      </div>
      {Number(fieldValue) !== defaultValue && (
        <div className={classes.saveIconButton} onClick={saveDiscount}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

const ClassPriceField = ({ user, userClass, onUpdate }) => {
  const addAlert = useAddAlert()
  const defaultValue = userClass.classUser?.amount
    ? Number(userClass.classUser?.amount ?? 0) +
      Number(userClass.classUser?.discount ?? 0)
    : 0
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const savePrice = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить цену',
      })
    }

    let params = {
      class_id: userClass?.id,
      amount: Number(fieldValue) - Number(userClass.classUser?.discount ?? 0),
      user_id: user.id,
    }
    classApi
      .changePriceForChild(params)
      .then((e) => {
        if (e.data.error) {
          onError()
        } else {
          addAlert({
            title: 'Цена обновлена',
          })
          onUpdate()
        }
      })
      .catch((e) => {
        onError()
      })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      Цена
      <div className={classes.smallFieldWrapper}>
        <input
          className={classNames(
            classes.inputSmallWithTrailingIcon,
            classes.directionAdditionalDescriptionTitle,
          )}
          value={fieldValue}
          placeholder="0"
          type="number"
          onChange={handleChange}
        />
        <div className={classes.directionAdditionalDescriptionTitle}>руб.</div>
      </div>
      {Number(fieldValue) !== defaultValue && (
        <div className={classes.saveIconButton} onClick={savePrice}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

const CourseDiscountField = ({ user, order, onUpdate = () => {} }) => {
  const addAlert = useAddAlert()
  const defaultValue = Number(order?.discount ?? 0)
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const saveDiscount = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить скидку',
      })
    }

    let params = {
      order_id: order?.id,
      discount: Number(fieldValue),
      // discount_currency: 'rub',
      user_id: user.id,
    }

    directionOrdersApi.changeDiscountForChild(params).then(({ data }) => {
      if (data?.status === 'success') {
        addAlert({
          title: 'Скидка обновлена',
        })
        onUpdate()
      } else {
        onError()
      }
    })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      <div className={classes.wrapper}>
        <div className={classes.directionDescriptionTitle}>Скидка</div>
        <div className={classes.smallFieldWrapper}>
          <input
            className={classNames(
              classes.inputSmallWithTrailingIcon,
              classes.directionAdditionalDescriptionTitle,
            )}
            value={fieldValue}
            placeholder="0"
            type="number"
            onChange={handleChange}
          />
          <div className={classes.directionAdditionalDescriptionTitle}>
            руб.
          </div>
        </div>
      </div>
      {Number(fieldValue) !== defaultValue && (
        <div className={classes.saveIconButton} onClick={saveDiscount}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

const CoursePriceField = ({ user, order, onUpdate = () => {} }) => {
  const addAlert = useAddAlert()
  const defaultValue = order?.payment_amount
    ? Number(order?.payment_amount ?? 0) + Number(order?.discount ?? 0)
    : 0
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const savePrice = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить цену',
      })
    }

    let params = {
      order_id: order?.id,
      payment_amount: Number(fieldValue) - Number(order?.discount ?? 0),
      user_id: user.id,
    }
    directionOrdersApi.changePriceForChild(params).then(({ data }) => {
      if (data?.status === 'success') {
        addAlert({
          title: 'Цена обновлена',
        })
        onUpdate()
      } else {
        onError()
      }
    })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      <div className={classes.wrapper}>
        <div className={classes.directionDescriptionTitle}>Цена</div>
        <div className={classes.smallFieldWrapper}>
          <input
            className={classNames(
              classes.inputSmallWithTrailingIcon,
              classes.directionAdditionalDescriptionTitle,
            )}
            value={fieldValue}
            placeholder="0"
            type="number"
            onChange={handleChange}
          />
          <div className={classes.directionAdditionalDescriptionTitle}>
            руб.
          </div>
        </div>
      </div>
      {Number(fieldValue) !== defaultValue && (
        <div className={classes.saveIconButton} onClick={savePrice}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

function formatTimestampDate(timestamp) {
  const date = new Date(timestamp * 1000)

  const formattedDate = date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  return `${formattedDate}`
}

function formatLastActionTime(time) {
  if (!time) {
    return 'нет активности'
  }

  const date = new Date(time)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}.${month}.${year}, ${hours}:${minutes}`
}

const StudentProfileFooter = ({ student, onAction }) => {
  const [settings, setSettings] = useState({})
  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])
  const userIdsAllowedToDeleteStudents = settings.userIdsAllowedToDeleteStudents
    ? JSON.parse(settings.userIdsAllowedToDeleteStudents)
    : []
  const selectEmployeesWhoAreAllowedDeleteStudents =
    settings.selectEmployeesWhoAreAllowedDeleteStudents === '1'

  const profile = useSelector(selectProfile)

  const actions = [
    { label: 'Сохранить', action: 'save' },
    { label: 'Отмена', action: 'cancel' },
    { label: 'Сбросить пароль', action: 'resetPassword' },
    { label: 'Авторизоваться', action: 'authorize' },
    ...(userIdsAllowedToDeleteStudents.includes(profile.id) ||
    !selectEmployeesWhoAreAllowedDeleteStudents
      ? [
          {
            label: student?.status === 0 ? 'Разблокировать' : 'Заблокировать',
            action: 'block',
          },
        ]
      : []),
    ...(userIdsAllowedToDeleteStudents.includes(profile.id) ||
    !selectEmployeesWhoAreAllowedDeleteStudents
      ? [
          {
            label: student?.status === 9 ? 'Восстановить' : 'Удалить',
            action: 'delete',
          },
        ]
      : []),
  ]

  return (
    <div className={classes.footerContainer}>
      {actions.map(({ label, action }) => (
        <Button
          key={action}
          newDesign
          className={classNames(classes.footerButton, classes.truncateText)}
          onClick={() => onAction(action)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

const toBoolean = (value) => {
  return value === '1' || value === true
}

const CourseInClass = ({
  name,
  tariffName,
  directionId,
  directionOrderId,
  group,
  getDirection,
  fetchClasses,
  seminarianName,
  userIdsAllowedToDeleteCourses,
  selectEmployeesWhoAreAllowedDeleteCourses,
  profile,
  handleDetachGroup,
  userClass,
  index,
}) => {
  return (
    <div className={classes.directionCourseItem} key={index}>
      <div
        className={classNames(
          classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        {name}
      </div>
      <div
        className={classNames(
          classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        {tariffName}
      </div>
      <div
        className={classNames(
          // classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        <ChangeGroupCell
          className={classes.directionTableChangeGroupCell}
          directionId={directionId}
          directionOrderId={directionOrderId}
          selectedGroup={group}
          refetchData={() => {
            getDirection()
            fetchClasses()
          }}
        />
      </div>
      <div
        className={classNames(
          classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        {seminarianName}
      </div>
      {(userIdsAllowedToDeleteCourses.includes(profile.id) ||
        !selectEmployeesWhoAreAllowedDeleteCourses) && (
        <div
          onClick={() => {
            handleDetachGroup(group, userClass)
          }}
          className={classNames(classes.secondaryIcon, classes.deleteDirection)}
        >
          <IcoRemove />
        </div>
      )}
    </div>
  )
}

export default EditStudentModal
